<div class="interested-events-container" *ngIf="interestedEvents && interestedEvents.length > 0">
  <h3 class="interested-event-title">
    {{ "shared.labels.interestedEvent" | translate }}
  </h3>

  <div class="campain">
    <div class="profileCampaign" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="space-between center"
      *ngIf="profileCampaign">


      <div class="campainGroup" fxLayout="column" fxLayoutGap="5px">
        <div class="campainName">
          <p mat-dialog-title>{{ profileCampaign.sname }}</p>
        </div>
        <div class="campainDescription">
          <p mat-dialog-title>{{ profileCampaign.lname }}</p>
        </div>
      </div>
      <div class="see-details">
        <a (click)="seeDetail()" mat-button>
          {{ "shared.labels.seeDetails" | translate }}
          <mat-icon>arrow_forward</mat-icon>
        </a>
      </div>
    </div>
  </div>

    <div class="nonSlide" fxLayout="row wrap" fxLayoutAlign="space-between center">
      <ng-template [ngIf]="!slideStart" *ngFor="let interestedEvent of interestedEvents">
          <div class="interested-event-item no-slide" fxLayout="column">
            <a [href]="generateHref(interestedEvent.eventCode, region, lang)">
              <img [src]="interestedEvent.eventImage | secureImage" alt="" loading="lazy"/>
              <h3>{{ interestedEvent.eventName }}</h3>
            </a>

            <btx-event-description [venueName]="interestedEvent.venueName" [venueCity]="interestedEvent.venueCity"
              [startDate]="interestedEvent.firstActivePerformanceDate"
              [endDate]="interestedEvent.lastActivePerformanceDate" [multiDate]="
                interestedEvent.firstActivePerformanceDate !=
                interestedEvent.lastActivePerformanceDate
              ">
            </btx-event-description>
          </div>
      </ng-template>
    </div>
    <ng-template [ngIf]="slideStart">
      <div class="swiper-wrapper" fxLayout="row wrap" >
        <swiper class="my-swiper" [loop]="true" [spaceBetween]="20" [slidesPerView]="3" [loopAdditionalSlides]="2" [centeredSlides]="true" [lazy]="{ loadPrevNext: true }">
          <ng-template *ngFor="let interestedEvent of interestedEvents" swiperSlide>
            <div class="interested-event-item" fxLayout="column" >
              <a [routerLink]="[
                  '/etkinlik',
                  interestedEvent.eventCode,
                  region,
                  lang
                ]">
                <img [attr.data-src]="interestedEvent.eventImage | image" alt="" class="swiper-lazy" loading="lazy"/>
                <h3>{{ interestedEvent.eventName }}</h3>
              </a>

              <btx-event-description [venueName]="interestedEvent.venueName" [venueCity]="interestedEvent.venueCity"
                [startDate]="interestedEvent.firstActivePerformanceDate"
                [endDate]="interestedEvent.lastActivePerformanceDate" [multiDate]="
                  interestedEvent.firstActivePerformanceDate !=
                  interestedEvent.lastActivePerformanceDate
                ">
              </btx-event-description>
            </div>
          </ng-template>
        </swiper>
        <div>
          <button class="btn-next" (click)="swipeNext()">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
        </div>
        <div>
          <button class="btn-prev" (click)="swipePrev()">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
        </div>
      </div>
    </ng-template>
  
  <div class="button-actions text-center">
    <a [href]="[profileCampaign?.campaignUrl]" mat-stroked-button color="primary" class="see-more-btn">
      {{ "shared.labels.seeAllEvents" | translate }}
    </a>
  </div>
</div>
<div fxLayout="row" class="interested-event-description" id="seeDetail" *ngIf="profileCampaign">
  <div class="interested-event-logo"
    *ngIf="profileCampaignImage && profileCampaignImage != 'assets/images/noimage.gif'">
    <img *ngIf="profileCampaignImage" [src]="profileCampaignImage" alt="credit card profile image" loading="lazy" />
  </div>
  
  <div fxLayout="column" fxLayoutGap="5px">
    <div class="interested-event-sname">
      {{ profileCampaign.sname }}
    </div>
    <div class="interested-event-lname">
      {{ profileCampaign.description }}
    </div>
  </div>
</div>